import React from "react";

export function NotFoundTemplate() {
  return <div>Not found!</div>;
}
